import BaseComponent from './BaseComponent'

class SelectableCard extends BaseComponent {
  constructor(componentName) {
    super(componentName)
  }

  init(component) {
    const element = component.element

    if (element.dataset.role === 'checkbox') {
      this.initCheckbox(element)
    } else if (element.dataset.role === 'deselect-all') {
      this.initDeselectAll(element)
    } else if (element.dataset.role === 'counter') {
      this.counterElement = element
      this.initFilterFormInterceptor()
    }
  }

  getCheckboxes() {
    return document.querySelectorAll('.selectable-card-checkbox')
  }

  initCheckbox(element) {
    element.addEventListener('change', () => {
      const card = element.closest('.selectable-variant')
      if (card) {
        card.classList.toggle('is-selected', element.checked)
      }
      this.updateCounter()
    })
  }

  initDeselectAll(element) {
    element.addEventListener('click', (event) => {
      event.preventDefault()
      if (!confirm('This will deselect all products. If you save, all highlighted products will be removed. Click Cancel to undo.')) {
        return
      }
      const checkboxes = this.getCheckboxes()
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false
        const card = checkbox.closest('.selectable-variant')
        if (card) {
          card.classList.remove('is-selected')
        }
      })
      document.querySelectorAll('#highlighted-variants-form input[type="hidden"][name="variant_ids[]"]')
        .forEach((input) => input.remove())
      this.updateCounter()
    })
  }

  updateCounter() {
    if (!this.counterElement) return

    const checkedCount = this.getSelectedIds().length
    this.counterElement.textContent = `${checkedCount} selected`
  }

  getSelectedIds() {
    const checkedIds = Array.from(document.querySelectorAll('.selectable-card-checkbox:checked'))
      .map((checkbox) => checkbox.value)
    const hiddenIds = Array.from(document.querySelectorAll('#highlighted-variants-form input[type="hidden"][name="variant_ids[]"]'))
      .map((input) => input.value)
    const allIds = new Set([...checkedIds, ...hiddenIds])
    return Array.from(allIds)
  }

  injectSelectedIds(form) {
    form.querySelectorAll('input[name="selected_ids[]"]').forEach((input) => input.remove())
    this.getSelectedIds().forEach((id) => {
      const hidden = document.createElement('input')
      hidden.type = 'hidden'
      hidden.name = 'selected_ids[]'
      hidden.value = id
      form.appendChild(hidden)
    })
  }

  initFilterFormInterceptor() {
    const filterForm = document.querySelector('.section--filters form')
    if (!filterForm || filterForm.dataset.selectionIntercepted) return

    filterForm.dataset.selectionIntercepted = 'true'

    // Intercept the submit event (covers Enter key in search)
    filterForm.addEventListener('submit', () => {
      this.injectSelectedIds(filterForm)
    })

    // Override native form.submit() since inline onchange handlers
    // call this.form.submit() directly, which does not fire the submit event
    const originalSubmit = filterForm.submit.bind(filterForm)
    filterForm.submit = () => {
      this.injectSelectedIds(filterForm)
      originalSubmit()
    }

    // Intercept clear filters button — it's a plain <a> link that would
    // lose all selections. Append selected_ids as query params to its href.
    const clearButton = filterForm.querySelector('.btn--clear')
    if (clearButton) {
      clearButton.addEventListener('click', (event) => {
        event.preventDefault()
        const selectedIds = this.getSelectedIds()
        const url = new URL(clearButton.href)
        selectedIds.forEach((id) => url.searchParams.append('selected_ids[]', id))
        window.location.href = url.toString()
      })
    }
  }
}

export default SelectableCard
